module.exports = __webpack_public_path__ + "img/yusuan.632066dd.png";